/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown> }} Email_Task_Assigned_Subject_FallbackInputs */

const en_email_task_assigned_subject_fallback = /** @type {(inputs: Email_Task_Assigned_Subject_FallbackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`New task: ${i?.task}`)
};

const pt_br2_email_task_assigned_subject_fallback = /** @type {(inputs: Email_Task_Assigned_Subject_FallbackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nova atividade: ${i?.task}`)
};

/**
* | output |
* | --- |
* | "New task: {task}" |
*
* @param {Email_Task_Assigned_Subject_FallbackInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const email_task_assigned_subject_fallback = /** @type {((inputs: Email_Task_Assigned_Subject_FallbackInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Task_Assigned_Subject_FallbackInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_email_task_assigned_subject_fallback(inputs)
	return pt_br2_email_task_assigned_subject_fallback(inputs)
});